import api from './api';

const BASE_URL = '/api/sports-management';

export const regionsService = {
    getAll: (isActive = null) => {
        const params = isActive !== null ? { isActive } : {};
        return api.get(`${BASE_URL}/regions`, { params });
    },
    create: (data) => api.post(`${BASE_URL}/regions`, data),
    update: (id, data) => api.put(`${BASE_URL}/regions/${id}`, data),
    delete: (id) => api.delete(`${BASE_URL}/regions/${id}`)
};

export const facilitiesService = {
    getAll: (isActive = null, regionId = null) => {
        const params = {};
        if (isActive !== null) params.isActive = isActive;
        if (regionId !== null) params.regionId = regionId;
        return api.get(`${BASE_URL}/facilities`, { params });
    },
    create: (data) => api.post(`${BASE_URL}/facilities`, data),
    update: (id, data) => api.put(`${BASE_URL}/facilities/${id}`, data),
    delete: (id) => api.delete(`${BASE_URL}/facilities/${id}`)
};

export const pricingService = {
    getByFacility: (facilityId) => api.get(`${BASE_URL}/pricing`, { params: { facilityId } }),
    create: (data) => api.post(`${BASE_URL}/pricing`, data),
    delete: (id) => api.delete(`${BASE_URL}/pricing/${id}`)
};

export const blockedSlotsService = {
    getByFacility: (facilityId) => api.get(`${BASE_URL}/blocked-slots`, { params: { facilityId } }),
    create: (data) => api.post(`${BASE_URL}/blocked-slots`, data),
    delete: (id) => api.delete(`${BASE_URL}/blocked-slots/${id}`),
    getAvailableSlots: (facilityId, date, sportTypeId = null) => {
        const params = { date };
        if (sportTypeId) params.sportTypeId = sportTypeId;
        return api.get(`/api/sports/available-slots/${facilityId}`, { params });
    }
};

export const genderRestrictionsService = {
    getByFacility: (facilityId) => api.get(`${BASE_URL}/gender-restrictions`, { params: { facilityId } }),
    save: (data) => api.post(`${BASE_URL}/gender-restrictions`, data)
};

export const clubPricingService = {
    getByFacility: (facilityId) => api.get(`${BASE_URL}/club-pricing`, { params: { facilityId } }),
    save: (data) => api.post(`${BASE_URL}/club-pricing`, data),
    delete: (id) => api.delete(`${BASE_URL}/club-pricing/${id}`)
};

export const facilityTypes = [
    { id: 1, name: 'Tenis', icon: 'GiTennisRacket' },
    { id: 2, name: 'Futbol', icon: 'FaFutbol' },
    { id: 3, name: 'Basketbol', icon: 'FaBasketballBall' },
    { id: 4, name: 'Voleybol', icon: 'FaVolleyballBall' },
    { id: 5, name: 'Basketbol/Voleybol', icon: 'FaBasketballBall' },
    { id: 6, name: 'Kapalı Spor Havuzu', icon: 'FaSwimmingPool' }
];

export const daysOfWeek = [
    { id: 1, name: 'Pazartesi' },
    { id: 2, name: 'Salı' },
    { id: 3, name: 'Çarşamba' },
    { id: 4, name: 'Perşembe' },
    { id: 5, name: 'Cuma' },
    { id: 6, name: 'Cumartesi' },
    { id: 0, name: 'Pazar' }
];
